<template>
    <Layout>
        <div class="row">
            <div class="col-md-12">
                <b-card>
                    <PageHeader :title="title" :items="items" style="margin-top: -30px"/>
                    <form action="">
                        <div class="form-row">
                            <div class="col-md-6 col-sm-6 col-lg-6">
                                <label for="batch_id">Select Batch <span style="color: red">*</span></label>
                                <select v-model="search_data.batch_id" v-validate="'required'" id="batch_id" name="batch_id"
                                       class="form-control form-control-sm">
                                    <option :value="''" selected>Select Batch</option>
                                    <option v-for="(batch, index) in batches" :key="index" :value="batch.id">
                                        {{batch.trade.desc + " | " + "Batch No: " + batch.batch_no }}
                                    </option>
                                </select>
                                <div class="invalid-feedback">
                                    Please Select Batch
                                </div>
                            </div>
                            <div class="col-md-6 col-sm-6 col-lg-6 custom-search">
                                <button class="btn btn-success btn-sm custom-search-button" @click.prevent="search">
                                    Search
                                </button>
                            </div>
                        </div>

                    </form>
                </b-card>

                <b-card v-if="flag">
                    <div v-if="trainees.length > 0" class="row mb-2">
                        <div class="col-sm-4">
                            <span class="badge badge-success mr-2">Total Search Data Found: {{ trainees.length }}</span>
                        </div>
                    </div>
                    <div class="table-responsive" style="overflow-x: auto">
                        <table class="table table-centered table-striped">
                            <thead>
                            <tr>
                                <th>Name</th>
                                <th>Voucher</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(trainee, index) in trainees.trainees" :key="index">
                                <td width="20%">
                                    <router-link :to="{
                                    name: 'traineeView',
                                    params: { trainee_id: trainee.id } }" tag="a" target="_blank">

                                    <span v-for="image in trainee.files" :key="image.id" class="mr-1">
                                        <span v-if="image.file_tag === 'Household'">
                                          <img class="rounded-circle" :src="image.name" alt="" width="30px" height="30px"/>
                                        </span>
                                    </span>
                                        {{ trainee.name }}
                                    </router-link>
                                </td>
                                <td>
                                    <div class="table-responsive" style="overflow-x: auto">
                                        <table class="table table-centered table-striped">
                                            <thead>
                                            <tr>
                                                <th>SL</th>
                                                <th>Start Date</th>
                                                <th>End Date</th>
                                                <th>Total attendance</th>
                                                <th>Vat</th>
                                                <th>Tax</th>
                                                <th>Sub total</th>
                                                <th>Total</th>
                                                <th>Payment Date</th>
                                                <th>Is Debited</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr  v-for="(voucher, index) in trainee.voucher" :key="voucher.id">
                                                <td>{{ index + 1 }}</td>
                                                <td>{{ voucher.start_date }}</td>
                                                <td>{{ voucher.end_date }}</td>
                                                <td>{{ voucher.total_attendance }}</td>
                                                <td>{{ voucher.vat }}</td>
                                                <td>{{ voucher.tax }}</td>
                                                <td>{{ voucher.sub_total }}</td>
                                                <td>{{ voucher.total }}</td>
                                                <td>
                                                    <span v-if="voucher.payment_date !== null">{{ voucher.payment_date }}</span>
                                                    <span v-else>N/A</span>
                                                </td>
                                                <td>
                                                    <span v-if="voucher.is_debited === 1">Yes</span>
                                                    <span v-else>No</span>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                        <h5 v-if="trainee.voucher.length === 0" class="text-center text-secondary">
                                            No Voucher Found
                                        </h5>
                                    </div>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <h5 v-if="trainees.length === 0" class="text-center text-secondary">
                            No Data Found
                        </h5>
                    </div>
                </b-card>
                <add-payment
                        :voucher="voucher"
                        @search="search"
                        @getVoucher="getVoucher"
                        @resetForm="resetForm"
                       >
                </add-payment>
            </div>
        </div>
    </Layout>
</template>

<script>
    import appConfig from "@src/app.config";
    import Layout from "@layouts/main";
    import PageHeader from "@components/page-header";
    import http from "@state/http";

    import moment from "moment";
    import AddPayment from "../../modals/AddPayment.vue";

    import jsPDF from "jspdf";
    import html2canvas from "html2canvas"

    export default {
        page: {
            title: "Voucher",
            meta: [{ name: "description", content: appConfig.description }]
        },
        components: { Layout, PageHeader, AddPayment },
        data() {
            return {
                title: "Voucher List",
                items: [
                    {
                        text: "Dashboard",
                        href: "/"
                    },
                    {
                        text: "Voucher",
                        active: true
                    }
                ],

                batches: [],
                trainees: {},
                search_data: {
                    batch_id: ''
                },
                validation_errors: {},
                start_date: "",
                flag: false,
                voucher: {},
            };
        },

        mounted() {
            this.getBatches();
        },
        methods: {
            getBatches() {
                http.get("api/batch/trainee/getBatch").then(response => {
                    if (!response.error) {
                        this.batches = response.data.batches;
                    }
                });
            },
            search() {
                this.$validator.validate().then(valid => {
                    if (valid) {
                        http
                            .post("api/trainee/voucher/search", this.search_data)
                            .then(response => {
                                if (!response.error) {
                                    this.flag = true;
                                    this.trainees = response.data.trainees;
                                }
                            });
                    }
                });
            },
            customStartDate(date) {
                this.start_date = moment(date).format("YYYY-MM-DD");
                return moment(date).format("YYYY-MM-DD");
            },
            resetForm() {
                this.voucher = {};
            },
            getVoucher(voucher) {
                this.voucher = voucher;
            },
            onDelete(id, index) {
                if (confirm("Do you really want to delete?")) {
                    http.delete("api/trainee/voucher/delete/" + id).then(response => {
                        this.search();
                        this.$bvToast.toast(response.data.message, {
                            title: "Success",
                            autoHideDelay: 5000,
                            variant: "success"
                        });
                    });
                }
            },
            // pdf(id){
            //     http.post("api/trainee/voucher/pdf/"+id)
            //         .then()
            //         .catch()
            // }
            // pdf(id) {
            //     const doc = new jsPDF();
            //     /** WITHOUT CSS */
            //     const contentHtml = this.$refs.content.innerHTML;
            //     doc.fromHTML(contentHtml, 15, 15, {
            //         width: 170
            //     });
            //     doc.save("sample.pdf");
            // },

             pdf(id) {
                http.get('api/trainee/voucher/pdf', {responseType: 'arraybuffer'})
                    .then(response => {
                        let blob = new Blob([response.data], { type: 'application/pdf' }),
                            url = window.URL.createObjectURL(blob)

                        window.open(url)


                        // let blob = new Blob([response.data], { type: 'application/pdf' })
                        // let link = document.createElement('a')
                        // link.href = window.URL.createObjectURL(blob)
                        // link.download = 'test.pdf'
                        // link.click()
                    })
            }
        },
        computed: {
            userPermission () {
                return this.$store.state.user
            }
        },
        created () {
            this.$store.dispatch('getUserPermission')
        },
    };
</script>
<style lang="scss">
    .vdp-datepicker input {
        width: 100%;
        border-radius: 3px;
        border: 1px solid #ced4da;
        height: 30px;
        padding-left: 15px;
        color: #6b757d;
    }

    .c-container {
        margin-right: 5px;
    }
</style>